<div class="feature-category-tree border border-outline h-full flex flex-col"
  [class.has-error]="control().showError$ | async">
  <div class="tree-container flex-1 overflow-y-auto px-2 py-1">
    @if (isSearchable()) {
    <div class="mb-4 mt-2">
      <cac-field [control]="searchControl" label="Search categories" placeholder="Type to search..." controlType="input"
        class="w-full" />
    </div>
    }
    @if (!hideClear()) {
    <cac-button class="clear-btn mb-2" appearance="text" (click)="clear()">Clear</cac-button>
    }
    <mat-radio-group (change)="selectCategory($event.value)">
      @for (node of visibleNodes(); track node.id) {
      <div class="flex items-center py-2" [style.padding-left.px]="node.level * 30">
        <div class="flex items-center w-full">
          <div class="w-6 flex justify-center" *ngIf="allowParentSelection()">
            @if (node.expandable) {
            <button (click)="toggleNode(node)" class="focus:outline-none">
              <mat-icon [class.rotate-90]="isExpanded(node.id)" [svgIcon]="'chevron-right'" />
            </button>
            }
          </div>
          <div class="flex items-center">
            @if (!allowParentSelection() && node.expandable) {
            <button (click)="toggleNode(node)" class="flex items-center gap-1 focus:outline-none">
              <mat-icon [class.rotate-90]="isExpanded(node.id)" [svgIcon]="'chevron-right'" class="w-10 h-5"></mat-icon>
              <span>{{ shouldShowPriority(node) ? '[' + node.priority + '] ' : '' }}{{ node.name.english || node.name.arabic }}{{ shouldShowNodeCount(node) ? ' (' + node.productCount + ')' : '' }}</span>
            </button>
            } @else if (multiple()) {
            <mat-checkbox [value]="node.id.toString()" [checked]="control().value?.includes(node.id)"
              (change)="selectCategory(node.id)">
              {{ shouldShowPriority(node) ? '[' + node.priority + '] ' : '' }}{{ node.name.english || node.name.arabic }}{{ shouldShowNodeCount(node) ? ' (' + node.productCount + ')' : '' }}
            </mat-checkbox>
            } @else {
            <mat-radio-button [checked]="control().value === node.id" [value]="node.id">
              {{ shouldShowPriority(node) ? '[' + node.priority + '] ' : '' }}{{ node.name.english || node.name.arabic }}{{ shouldShowNodeCount(node) ? ' (' + node.productCount + ')' : '' }}
            </mat-radio-button>
            }
          </div>
        </div>
      </div>
      }
    </mat-radio-group>
    @if (!loading() && visibleNodes().length === 0) {
    <div class="py-4 text-center text-gray-500 text-sm">
      No categories available
    </div>
    }
  </div>
  @if (loading()) {
  <div class="w-full mb-4 px-2">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  }
  <cac-control-error [control]="control()" />
</div>